export class TemplateTypes {
    public static ContactDetails = "ContactDetails";
    public static ParticipantAppNotice = "ParticipantAppNotice";
    public static ClosedPeriodNotice = "ClosedPeriodNotice";
    public static ParticipantWelcomeNote = "ParticipantWelcomeNote";
    public static ParticipantPortfolioNote = "ParticipantPortfolioNote";
}